var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreaCovered(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 14.6667V35.5H5V25.5L8.33333 24.6667L14.1667 32.1667L26.6667 11.3334L39.1667 14.6667Z",
    fill: "#759A18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 16.1083V35.5H5.8335V30.6C5.83396 29.619 6.16224 28.6663 6.76619 27.8932C7.37013 27.1202 8.2151 26.5711 9.16683 26.3333C9.25016 26.3333 8.67516 25.7 15.0002 33.8333L27.5002 13L39.1668 16.1083Z",
    fill: "#ADDE34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 40.5H0.833333C0.61232 40.5 0.400358 40.4122 0.244078 40.2559C0.0877974 40.0996 0 39.8877 0 39.6667V1.33333C0 1.11232 0.0877974 0.900358 0.244078 0.744078C0.400358 0.587797 0.61232 0.5 0.833333 0.5C1.05435 0.5 1.26631 0.587797 1.42259 0.744078C1.57887 0.900358 1.66667 1.11232 1.66667 1.33333V38.8333H39.1667C39.3877 38.8333 39.5996 38.9211 39.7559 39.0774C39.9122 39.2337 40 39.4457 40 39.6667C40 39.8877 39.9122 40.0996 39.7559 40.2559C39.5996 40.4122 39.3877 40.5 39.1667 40.5Z",
    fill: "#151E15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 25.5V35.5H5V32.1667L13.3333 25.5L20 30.5L32.5 21.3334L39.1667 25.5Z",
    fill: "#151E15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 26.65V35.5H5.8335C5.83257 34.9799 5.94898 34.4662 6.17406 33.9973C6.39914 33.5284 6.72709 33.1163 7.1335 32.7917L14.1668 27.1667L20.8335 32.1667L33.3335 23L39.1668 26.65Z",
    fill: "#317153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaCovered);
export default __webpack_public_path__ + "static/media/area-covered.c26e1667ebd268f0102c961efb456dde.svg";
export { ForwardRef as ReactComponent };